import { Modal, ModalBody } from "reactstrap";
import { clearSession } from "../../common/sessionManager";

const SassionWarningModal = ({ show, onClose }) => {
    return (
        <>
            <Modal
                size="md"
                isOpen={show}
                toggle={onClose}
                backdrop={'static'}
                id="staticBackdrop1"
                centered
            >
                <ModalBody>
                    <div className="modal-body text-center p-5">
                        <i
                            className="ri-error-warning-line"
                            style={{ color: "#F0BB40", fontSize: "60px" }}
                        ></i>
                        <div className="mt-4">
                            <h4 className="mb-3">Session expired!</h4>
                            <p className="text-muted mb-4">
                                Your session has expired due to inactivity. Please log in again.
                            </p>
                            <div className="hstack gap-2 justify-content-center">
                                <button className="btn btn-primary" onClick={()=>{
                                  onClose()
                                  clearSession()
                                }}>
                                    Okay
                                </button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};

export default SassionWarningModal;
